import axios from 'axios';
import api from './endpoints';

export default {
  active() {
    return axios.get(api.SLIDER_IMAGES).then((result) => result.data);
  },
  list() {
    return axios.get(api.SECURE_SLIDER_IMAGES).then((result) => result.data);
  },
  update(args) {
    return axios.put(api.SECURE_SLIDER_IMAGES + '/' + args.id, args).then((result) => result.data);
  },
  create(args) {
    return axios.post(api.SECURE_SLIDER_IMAGES, args).then((result) => result.data);
  },
  delete(args) {
    return axios.delete(api.SECURE_SLIDER_IMAGES + '/' + args.id).then((result) => result.data);
  },
};
